import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';

import css from 'css';

import WP from 'WP';

import { h3Styles } from 'partials/typography';
import Container from 'partials/Container';
import SocialLinks from 'partials/SocialLinks';
import Html from 'partials/Html';

const FooterWrapper = styled.footer`
    background: ${css.colors.main};
    padding: 50px 0;

    &.has-cart {
        padding-bottom: 100px;
    }

    @media(min-width: 850px) {
        padding: 60px 0;
        &.has-cart {
            padding-bottom: 160px;
        }
    }

    .social-links {
        @media(max-width: 850px) {
            width:100%;
            display: flex;
            justify-content: space-between;
            padding-top:30px;
        }

        li {
            margin-bottom:30px;

            @media(max-width: 850px) {
                margin-bottom:0;
            }

            &:last-child {
                margin: 0;
            }

            a {
                font-size:18px;

                @media(max-width: 767px) {
                    font-size:0px;
                    color:${css.colors.main};

                    span{
                        margin-right:0;
                    }
                }
            }
        }
    }
`

const Columns = styled.div`
    display: flex;
    width:70%;
    justify-content: space-between;

    @media(max-width: 1000px) {
        width:80%;
    }

    @media(max-width: 850px) {
        width:100%;
    }

    @media(max-width: 767px) {
        flex-wrap: wrap;
    }
`

const Col = styled.div`
    color:#fff;

    @media(max-width: 767px) {
        width:100%;
    }

    .title {
        ${h3Styles}
        margin-bottom:15px;
    }

    > div {
        a {
            color: #fff;
            border-bottom: 1px solid #fff;

            &:hover, &:focus {
                color: #fff;
                border-bottom: 1px solid transparent;
                text-decoration: none;
            }
        }
    }
`

class Footer extends Component {
    componentDidMount() {
        this.mounted = true;
    }

    componentWillUnmount() {
        this.mounted = false;
    }

    _showCart() {
        const { courses, programs } = this.props.opportunity;

        return courses.length + programs.length > 0;
    }

    render() {
        const { cart } = this.props;

        return (
            <FooterWrapper className={this._showCart() ? 'has-cart' : ''}>
                <Container flex wrap justify="space-between">
                    <Columns>
                        <Col>
                            <div className="title"> Bjørknes Privatskole </div>
                            <Html content>{WP.options.footer_col_1}</Html>
                        </Col>
                        <Col>
                            <div className="title"> Åpningstider </div>
                            <Html content>{WP.options.footer_col_2}</Html>
                        </Col>
                        <Col>
                            <div className="title"> Studenter og ansatte </div>
                            <Html content>{WP.options.footer_col_3}</Html>
                        </Col>
                    </Columns>
                    <SocialLinks color="#fff" zoom />
                </Container>
            </FooterWrapper>
        );
    }
}

const mapStateToProps = state => ({
    opportunity: state.opportunity,
});

export default connect(mapStateToProps, {})(Footer);


// WEBPACK FOOTER //
// ./src/partials/Footer.js